<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-10">
                <!-- <div class="float-right">
                    <button class="btn dash-btns  " [routerLink]="['/pos/customer/manage']">Manage Customer</button>
                </div> -->
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div> -->
                                <div class="text-center">
                                    <a class="view-h gary-t">View Customer</a>
                                </div>

                                <div>
                                    <div>
                                        <div class="row mt-3">
                                            <div class="col-4 p-0"><label> Customer Name </label></div>

                                            <div class="col-7 view-text p-0"> {{rows.CustomerName }}</div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-4 p-0"><label> Customer Id</label></div>

                                            <div class="col-7 view-text p-0">
                                                <div class="robot">{{rows.CustomerId}}</div>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-4 p-0"><label> Email</label> </div>

                                            <div class="col-7 view-text p-0"> {{rows.Email}}</div>
                                        </div>
                                        <!-- <div class="row mt-3">
                                              <div class="col-4 p-0"> Address </div>
                                               
                                              <div class="col-7 view-text p-0"> {{rows.address}}</div>
                                          </div>
                                       
                                       -->
                                        <div class="row mt-3">
                                            <div class="col-4 p-0"> <label> Mobile Number</label> </div>

                                            <div class="col-7 view-text p-0">
                                                <div class="robot"> {{ rows.MobileNo }}</div>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-4 p-0"> <label> Notes</label></div>

                                            <div class="col-7 view-text p-0"> {{rows.Notes }}</div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-4 p-0"> <label> Business Name</label></div>

                                            <div class="col-7 view-text p-0"> {{rows.BusinessName}}</div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-4 p-0"> <label> Birth Day</label></div>

                                            <div class="col-7 view-text p-0"> {{rows.BirthDay}}</div>
                                        </div>
                                        <div class="row mt-3">

                                            <div class="col-4 p-0"><label> Contact Preference</label></div>

                                            <div class="col-7 view-text p-0"> {{rows.ContactPerference}}</div>
                                        </div>
                                        <div class="text-right py-2">
                                            <button class="btn dash-btns  " [routerLink]="['/pos/customer/manage']">Back</button>
                                                                           
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</div>